export default __webpack_public_path__ + "static/media/Novo_edital_sei.d0157c3c.pdf";